import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResposeGeneric } from 'src/app/core/shared/respose-generic';
import { AssigmentEvaluator } from './assigment-evaluator.model';
import { AssigmentEvaluatorSubject } from './assigment-evaluator-subject.model';
import { DeclineAssigment } from './decline-assigment.model';
import { SavedEvaluation } from './saved-evaluation.model';
import { SendEvaluationPifle } from './send-evaluation-pifle.model';

@Injectable()
export class AssesmentsService {

  uriAssesment = environment.urlServices + 'evaluadores';
  uriEvaluations = this.uriAssesment + '/evaluaciones';
  uriEvaluationsPifle = this.uriEvaluations + '/pifle';
  uriAssigment = this.uriAssesment + '/asignaciones';
  uriAssigmentSubject = this.uriAssigment + '/materias';
  uriDeclineAssigment = this.uriAssigment + '/declinaciones';

  constructor(private httpClient: HttpClient, private utilService: UtilityService) { }

  sendEvaluators(assigmentEvaluator: AssigmentEvaluator): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriAssigment, assigmentEvaluator);
  }

  sendEvaluatorBySubject(assigmentEvaluator: AssigmentEvaluatorSubject[]): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriAssigmentSubject, assigmentEvaluator);
  }

  declineAssigment(declineAssigment: DeclineAssigment): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriDeclineAssigment, declineAssigment);
  }

  savedEvaluation(savedEvaluation: SavedEvaluation) {
    return this.httpClient.post<ResposeGeneric>(this.uriEvaluations, savedEvaluation);
  }

  savedEvaluationPifle(sendEvaluationPifle: SendEvaluationPifle) {
    return this.httpClient.post<ResposeGeneric>(this.uriEvaluationsPifle, sendEvaluationPifle);
  }
}
